module.exports = __webpack_public_path__ + "img/flecha_arriba_activa.f849fc1d.svg";